// extracted by mini-css-extract-plugin
module.exports = {"winnerImage":"__5a_winnerImage__0_UlI","registerText":"__5a_registerText__nwZwR","signInText":"__5a_signInText__0gTw6","sideBar":"__5a_sideBar__3413A"};